import ITask, { IPoll, IPollOption } from "../../../models/Task";
import TaskService from "../../../services/TaskService";
import {
  Button
} from "@radix-ui/themes";
import { produce } from "immer";
// import { useRouter } from "next/router";
import React, { ReactNode, useState, useEffect } from "react";
import MultiChoicePoll from "../screens/MultipleChoicePoll";
import SingleChoicePoll from "../screens/SingleChoicePoll";
import { ConfirmSubmitPage } from "./ConfirmSubmitPage";
import axiosInstance from "../../../config/axios";
import PollResultBySesId from "./PollResultBySesId";
import { alertInstance } from "../../../components/alert";
import Wizard from "./Wizard";
import { useNavigate } from "react-router-dom";
import { User } from "models/User";
import { RootState } from "store";
import { useSelector } from "react-redux";


enum Step {
  Poll,
  ConfirmSubmit,
  SubmitSuccess,
  ViewResult,
}

interface PollProps {
  task: ITask;
}

const SubmitSuccessScreen = ({ setStep, shouldDisplayViewResultButton, disabledButton }: { setStep: React.Dispatch<React.SetStateAction<Step>>, shouldDisplayViewResultButton: boolean | undefined, disabledButton: boolean | undefined }) => {

  const router = useNavigate();

  return (
    <div className="flex flex-col gap-5 px-[1.5%]">
      <p>Thank You For Completing the Poll</p>
      <div className="flex flex-row gap-10">
        <Button
          color="purple"
          variant="solid"
          size="3"
          className="w-max"
          onClick={() => router(-1)}
        >
          Ok
        </Button>

        {shouldDisplayViewResultButton && (
          <Button
            color="purple"
            variant="solid"
            size="3"
            className="w-max"
            onClick={() => setStep(Step.ViewResult)}
          >
            View Result
          </Button>
        )}

        {disabledButton && (
          <>
            <Button
              color="teal"
              variant="solid"
              size="3"
              className="w-max"
              disabled
            >
              View Result
            </Button>
            <span className="ml-0 mt-2">Poll results will be available on Closure Date</span>

          </>
        )}

      </div>
    </div>
  );
};

const PollComponent: React.FC<PollProps> = ({ task }) => {
  const [step, setStep] = useState<Step>(Step.Poll);
  const taskService = new TaskService();
  const [polls, setPolls] = useState<IPoll[]>(task.polls);
  const [user, setUser] = useState<User>()
  const userState = useSelector((state: RootState) => state.auth.user as User);
  const [shouldDisplayViewResultButton, setShouldDisplayViewResultButton] = useState<boolean | undefined>(undefined);
  const [disabledButton, setDisabledButton] = useState<boolean | undefined>(undefined);
  const [activityData, setActivityData] = useState<any>(null);
  const [questionValidity, setQuestionValidity] = useState<Record<number, boolean>>(
    task.polls.reduce((acc, _, index) => ({ ...acc, [index]: false }), {})
  );
  const dueDate = task?.dueDate;
  console.log("disabledButton", disabledButton);



  const Screens: ReactNode[] = [];

  useEffect(() => {
    setUser(userState); 
  }, [userState]);

  useEffect(() => {
    if (!user?.id) return;

    const fetchData = async () => {
      try {
        const response = await axiosInstance.post("/programme/view_activity_status", {
          sessionSegmentId: task.id
        });

        const userActivityData = response.data.ActivityData?.filter(
          (el: any) => el?.traineeInfo?.id === user?.id
        );

        if (userActivityData?.length > 0) {
          const pollResultSettings = userActivityData[0]?.sharePollResultSettings;

          setShouldDisplayViewResultButton(pollResultSettings === 1);
          setDisabledButton(pollResultSettings === 2);
          setActivityData(userActivityData);
        } else {
          setShouldDisplayViewResultButton(false);
          setDisabledButton(false);
          setActivityData([]);
        }
      } catch (error) {
        console.error("Error fetching activity data:", error);
      }
    };

    fetchData();
  }, [user, task.id, task.dueDate]);

  function isPollClosed() {
    return new Date(dueDate as string) && new Date() > new Date(dueDate as string);
  }
  const handleMultichoiceAnswer = (option: IPollOption, index: number): void => {
    setPolls(
      produce(polls, (draft) => {
        draft[index].options.forEach((el) => {
          if (el.id === option.id) {
            el.isSelected = !el.isSelected;
          }
        });
      })
    );
    handleQuestionValidation(index, polls[index].options.some((opt) => opt.isSelected));
  };

  const handleSinglechoiceAnswer = (option: IPollOption, index: number): void => {
    setPolls((prevPolls) =>
      prevPolls.map((poll, i) =>
        i === index
          ? {
            ...poll,
            options: poll.options.map((el) => ({
              ...el,
              isSelected: el.id === option.id,
            })),
          }
          : poll
      )
    );
    handleQuestionValidation(index, true); 
  };;
  // useEffect(() => {
  //   console.log("🚀 ~ polls:", polls)
  // },[polls])

  const handleQuestionValidation = (index: number, isValid: boolean) => {
    setQuestionValidity((prev) => ({
      ...prev,
      [index]: isValid,
    }));
  };

  polls.forEach((el, index) => {
    if (el.isMultipleChoice) {
      Screens.push(<MultiChoicePoll onCheck={handleMultichoiceAnswer} question={el.question} options={el.options} index={index} isMandatory={true} onValidate={handleQuestionValidation}></MultiChoicePoll>)
    }
    else {
      Screens.push(<SingleChoicePoll onCheck={handleSinglechoiceAnswer} question={el.question} options={el.options} index={index} isMandatory={true} onValidate={handleQuestionValidation}></SingleChoicePoll>)
    }
  })

  const handleSubmit = async () => {
    let requestData: [{ ans: any[] }] = [{ ans: [] }];

    polls.forEach(el => {
      let answer = {
        question: el.question,
        id: el.id,
        answer: el.options.map(el => {
          const answer: { id: string, participantsName: string, answerValue: string, isAnswer: boolean } = {
            id: el.id,
            participantsName: userState.name,
            answerValue: el.option,
            isAnswer: el.isSelected,
          }
          return answer;
        }),
        allowMultipleVoting: el.isMultipleChoice,
        keepResponsesAnonymous: el.keepResponsesAnonymous
      }
      requestData[0].ans.push(answer);
    });

    const res: any = await taskService.submit(task?.id, requestData);
    if (res.code === 200) {
      setStep(Step.SubmitSuccess);
    } else {
      alertInstance.emit("showAlert", {
        type: "error",
        heading: "Something Went Wrong",
        buttonText: "ok",
      });
    }
  };

  return (
    <>
      {step === Step.Poll && (
        <Wizard
          heading={""}
          handleSubmit={() => setStep(Step.ConfirmSubmit)}
          steps={Screens}
          questionValidity={questionValidity}
        />
      )}

      {step === Step.ConfirmSubmit && (
        <ConfirmSubmitPage
          onSubmit={handleSubmit}
          setStep={setStep}
          prevStep={Step.Poll}
          reviewResponse={true}
        />
      )}
      {step === Step.SubmitSuccess && <SubmitSuccessScreen setStep={setStep} shouldDisplayViewResultButton={shouldDisplayViewResultButton} disabledButton={disabledButton} />}

      {step === Step.ViewResult && <PollResultBySesId sessionSegmentId={task.id} />}
    </>
  );
};

export default PollComponent;
